/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { CoreAppStore } from '@opengeoweb/store';
import { uiActions, uiSelectors } from '@opengeoweb/store';
import {
  warningEventDialogType,
  warningEventsSummaryDialogType,
} from '../../../store/warningsForm/utils';

export const useCloseWarningEventDialogOnUnmount = (panelId: string): void => {
  const dispatch = useDispatch();

  const isDialogOpen = useSelector((store: CoreAppStore) =>
    uiSelectors.getisDialogOpen(store, warningEventDialogType),
  );
  const sourcePanelId = useSelector((store: CoreAppStore) =>
    uiSelectors.getSourcePanelId(store, warningEventDialogType),
  );

  const dialogStateRef = React.useRef({ isDialogOpen, sourcePanelId, panelId });
  dialogStateRef.current = { isDialogOpen, sourcePanelId, panelId };

  React.useEffect(() => {
    return (): void => {
      const { current } = dialogStateRef;
      if (!current.isDialogOpen || current.sourcePanelId !== current.panelId) {
        return;
      }

      dispatch(
        uiActions.setToggleOpenDialog({
          setOpen: false,
          type: warningEventDialogType,
        }),
      );
      dispatch(
        uiActions.setToggleOpenDialog({
          setOpen: false,
          type: warningEventsSummaryDialogType,
        }),
      );
    };
  }, [dispatch]);
};
